export class User {
    id: number;
    email: string;
    token: string;
    name: string;
    level_id: number;
    ip: string;
    designation: string;
    mobile_number: number;
    level_name: string;
    status: number | null;
    logo:string;
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/models/user.model.ts